import { ModalAllder } from 'layouts/ModalAllder';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import 'react-clock/dist/Clock.css';
import 'react-datepicker/dist/react-datepicker.css';
import { useDispatch } from 'react-redux';
import 'react-time-picker/dist/TimePicker.css';
import { branchTagHandler } from '../../../../redux/handlers';

export default function ConfirmDeleteModal({ modal, setModal, businessSlug, tagdata, onSuccess, onHide, ...props }) {
  const dispatch = useDispatch();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    if (!tagdata?.id) {
      console.error('No tag ID provided for deletion');
      return;
    }

    try {
      setIsDeleting(true);
      const result = await dispatch(branchTagHandler.deleteBranchTag(businessSlug, tagdata.id));
      if (result) {
        if (onSuccess) {
          onSuccess();
        }
      }
    } catch (error) {
      console.error('Error deleting tag:', error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleCancel = () => {
    if (onHide) {
      onHide();
    }
  };

  return (
    <ModalAllder modal={modal} setModal={setModal} htitle={'ยืนยันการลบ'} hbtn={false}>
      <div className="py-4">
        <div>
          <div>
            <div className="text-center fs-22 tc-7 mb-2">คุณต้องการลบ</div>
            <div className="text-center fs-22 tc-7 mb-2">Tag "{tagdata?.name || tagdata?.tagName || ''}"</div>
            <div className="text-center fs-22 tc-7">ใช่หรือไม่</div>
          </div>

          <div className="text-center pt-4 mt-3 btn-group-control">
            <Button
              type="button"
              className="btn-st-3 mx-3"
              style={{ width: '100px' }}
              onClick={handleDelete}
              disabled={isDeleting}
            >
              ใช่
            </Button>
            <Button
              type="button"
              className="btn-st-6 mx-3"
              style={{ width: '100px' }}
              onClick={handleCancel}
              disabled={isDeleting}
            >
              ไม่ใช่
            </Button>
          </div>
        </div>
      </div>
    </ModalAllder>
  );
}
